import { I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export enum CreateModalStep {
  DevicesAndMetrics,
  TimePeriod,
  FormatAndRecipients,
  Schedule,
  Summary,
}

export const stepList = [
  CreateModalStep.DevicesAndMetrics,
  CreateModalStep.TimePeriod,
  CreateModalStep.FormatAndRecipients,
  CreateModalStep.Schedule,
  CreateModalStep.Summary,
];

export const getStepAttributes = (step: CreateModalStep, i18n: I18n) => {
  const translations = {
    [CreateModalStep.DevicesAndMetrics]: {
      title: t(i18n)`Dispositivos y métricas`,
    },
    [CreateModalStep.TimePeriod]: {
      title: t(i18n)`Periodo de tiempo`,
    },
    [CreateModalStep.FormatAndRecipients]: {
      title: t(i18n)`Formato y destinatarios`,
    },
    [CreateModalStep.Schedule]: {
      title: t(i18n)`Plantilla y programación`,
    },
    [CreateModalStep.Summary]: {
      title: t(i18n)`Resumen`,
    },
  };

  return translations[step];
};
